<template>
  <div>
    <form id="payment-form">
      <slot name="card-element">
        <div id="card-element"></div>
      </slot>
      <slot name="card-errors">
        <div id="card-errors" role="alert"></div>
      </slot>
      <button ref="submitButtonRef" type="submit"></button>
    </form>
  </div>
</template>

<script>
import { loadStripeCheckout } from "./load-checkout";

export default {
  name: "StripeElements",
  props: {
    pk: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      default: undefined
    },
    sessionId: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      stripe: null,
      elements: null,
      card: null
    };
  },
  computed: {
    style() {
      return {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };
    },
    form() {
      return document.getElementById("payment-form");
    }
  },
  methods: {
    submit() {
      this.$refs.submitButtonRef.click();
    }
  },
  mounted() {
    let context = this;
    loadStripeCheckout(context.pk, "v3", () => {
      context.stripe = window.Stripe(context.pk);
      context.elements = context.stripe.elements();
      context.card = context.elements.create("card", { style: context.style });
      context.card.mount("#card-element");
      context.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });

      context.form.addEventListener("submit", async event => {
        try {
          context.$emit("loading", true);
          event.preventDefault();

          const { paymentMethod, error } = await context.stripe.createPaymentMethod({
            type: "card",
            card: context.card,
            billing_details: {
              name: "Chris Li"
            }
          });
          if (error) {
            const errorElement = document.getElementById("card-errors");
            errorElement.textContent = error.message;
            console.error(error);
            context.$emit("error", error);
          } else {
            context.$emit("paymentMethod", paymentMethod);
          }
        } catch (error) {
          console.error(error);
          context.$emit("error", error);
        } finally {
          context.$emit("loading", false);
        }
      });
    });
  }
};
</script>

<style scoped>
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}
.StripeElement--invalid {
  border-color: #fa755a;
}
.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>